export type EmergencyContactCreateDestination = {
  view: 'list' | 'form';
  path: string;
};

export function destinationAfterEmergencyContactCreate(input: {
  saved: boolean;
}): EmergencyContactCreateDestination {
  if (input.saved) {
    return { view: 'list', path: '/emergency-contacts' };
  }
  return { view: 'form', path: '/emergency-contact/new' };
}
